const achievementsDroparea = document.querySelector(".js-achievements-droparea-init");

if (achievementsDroparea) {
    globalThis.ret.dragAndDropInit(achievementsDroparea);
}
